import styled from "styled-components";
import { FC } from "react";
import { observer } from "mobx-react";

const KeyboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  @media(max-width: 520px) {
    display: none;
  }
`;

const KeyboardButton = styled.div`
  line-height: 52px;
  padding-left: 20px;
  padding-right: 20px;
  background: #eee;
  text-align: center;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.3s;
  user-select: none;
  :hover {
    background: #e4e4e4;
  }
`;

const KeyboardRow = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;

const Keyboard: FC<{ type?: "default" | "phone"; onClick: Function; isUpperCase?: boolean }> = observer(({ type, onClick, isUpperCase }) => {
  if (type && type === "phone") {
    return (
      <KeyboardContainer>
        <KeyboardRow>
          <KeyboardButton onClick={() => onClick("1")}>1</KeyboardButton>
          <KeyboardButton onClick={() => onClick("2")}>2</KeyboardButton>
          <KeyboardButton onClick={() => onClick("3")}>3</KeyboardButton>
        </KeyboardRow>
        <KeyboardRow>
          <KeyboardButton onClick={() => onClick("4")}>4</KeyboardButton>
          <KeyboardButton onClick={() => onClick("5")}>5</KeyboardButton>
          <KeyboardButton onClick={() => onClick("6")}>6</KeyboardButton>
        </KeyboardRow>
        <KeyboardRow>
          <KeyboardButton onClick={() => onClick("7")}>7</KeyboardButton>
          <KeyboardButton onClick={() => onClick("8")}>8</KeyboardButton>
          <KeyboardButton onClick={() => onClick("9")}>9</KeyboardButton>
        </KeyboardRow>
        <KeyboardRow>
          <KeyboardButton onClick={() => onClick("+")}>+</KeyboardButton>
          <KeyboardButton onClick={() => onClick("0")}>0</KeyboardButton>
          <KeyboardButton onClick={() => onClick("<-")}>{"<-"}</KeyboardButton>
        </KeyboardRow>
      </KeyboardContainer>
    );
  }
  return (
    <KeyboardContainer style={{ textTransform: isUpperCase ? "uppercase" : "none" }}>
      <KeyboardRow>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "й".toUpperCase() : "й")}>й</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "ц".toUpperCase() : "ц")}>ц</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "у".toUpperCase() : "у")}>у</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "к".toUpperCase() : "к")}>к</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "е".toUpperCase() : "е")}>е</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "н".toUpperCase() : "н")}>н</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "г".toUpperCase() : "г")}>г</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "ш".toUpperCase() : "ш")}>ш</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "щ".toUpperCase() : "щ")}>щ</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "з".toUpperCase() : "з")}>з</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "х".toUpperCase() : "х")}>х</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "ъ".toUpperCase() : "ъ")}>ъ</KeyboardButton>
      </KeyboardRow>
      <KeyboardRow>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "ф".toUpperCase() : "ф")}>ф</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "ы".toUpperCase() : "ы")}>ы</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "в".toUpperCase() : "в")}>в</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "а".toUpperCase() : "а")}>а</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "п".toUpperCase() : "п")}>п</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "р".toUpperCase() : "р")}>р</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "о".toUpperCase() : "о")}>о</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "л".toUpperCase() : "л")}>л</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "д".toUpperCase() : "д")}>д</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "ж".toUpperCase() : "ж")}>ж</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "э".toUpperCase() : "э")}>э</KeyboardButton>
      </KeyboardRow>
      <KeyboardRow>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "я".toUpperCase() : "я")}>я</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "ч".toUpperCase() : "ч")}>ч</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "с".toUpperCase() : "с")}>с</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "м".toUpperCase() : "м")}>м</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "и".toUpperCase() : "и")}>и</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "т".toUpperCase() : "т")}>т</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "ь".toUpperCase() : "ь")}>ь</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "б".toUpperCase() : "б")}>б</KeyboardButton>
        <KeyboardButton onClick={() => onClick(isUpperCase ? "ю".toUpperCase() : "ю")}>ю</KeyboardButton>
      </KeyboardRow>
      <KeyboardRow>
        <KeyboardButton onClick={() => onClick("SH")}>{isUpperCase ? "Строчная" : "Заглавная"}</KeyboardButton>
        <KeyboardButton onClick={() => onClick(" ")}>Пробел</KeyboardButton>
        <KeyboardButton onClick={() => onClick("<-")}>Стереть</KeyboardButton>
      </KeyboardRow>
    </KeyboardContainer>
  );
});

export default Keyboard;
